@if (!screen) {
  <app-loader [isLoading]="!screen" class="load-indicator" id="MainConsoleDisplay"></app-loader>
}
<div class="background-gradient">
  <div class="left-rect"></div>
  <div class="right-rect"></div>
</div>
<div class="inviteinfo">
  <div class="nf-icon"></div>

  @if (screen === 'review') {
    <div class="content-area" id="AcceptForm" [ngClass]="{'dark-theme': environment.defaultTheme === 'dark'}">
      <div class="row center">
        <div [ngClass]="environmentLogoClass" class="invite-title">New Invitation</div>
      </div>
      <div class="center-group">
        <span class="org-invite-subtitle">You've been invited to join a NetFoundry organization</span>
      </div>
      <div class="center-group">
        <div class="title row center">Your organization name is:</div>
        <div class="title row center">
          <strong class="tenant-label-title">{{ invitation['toTenantLabel'] }} </strong>
        </div>
      </div>
      <div class="center-group">
        <div class="sub-org-name-text">Please remember your organization name. You will need it for future logins</div>
        <div class="expire-subtext">This invite will expire {{ expires }}</div>
      </div>
      @if (showAcceptError) {
        <div class="center-group">
          <div class="accept-notice" id="AcceptError" role="alert">
            <span class="accept-notice__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M12 7.5v5.5" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" />
                <circle cx="12" cy="16.6" r="1.35" fill="currentColor" />
              </svg>
            </span>
            <span class="accept-notice__body">
              <span class="accept-notice__title">We couldn't complete your sign-in</span>
              <span class="accept-notice__text">
                The account you signed in with may not match this invitation. It's still valid — select
                <strong>Accept</strong> to try again.
              </span>
            </span>
          </div>
        </div>
      }
      <div class="center-group">
        <div (click)="accept()" class="button accept-button" id="AcceptButton">Accept</div>
      </div>
      <div class="center-group">
        <span>or</span>
        <span (click)="decline()" class="goto labelLink center">Decline</span>
      </div>
    </div>
  }

  @if (screen === 'declined') {
    <div class="content-area">
      <div class="row center">
        <div [ngClass]="environmentLogoClass" class="invite-title">Invitation Declined</div>
      </div>
      <div class="subTitle row">
        <span class="subtitle-header">This invitation has been declined.</span>
        <span>If you believe this is an error, please contact your system administrator to request a new invitation.</span>
      </div>
    </div>
  }

  @if (screen === 'inuse') {
    <div class="content-area">
      <div class="row center">
        <div [ngClass]="environmentLogoClass" class="invite-title">Invitation Accepted</div>
      </div>
      <div class="subTitle row">
        <span class="subtitle-header">This invitation has already been accepted.</span>
        <span>If you believe this is an error, please contact your system administrator to request a new invitation.</span>
      </div>
    </div>
  }

  @if (screen === 'expired') {
    <div class="content-area">
      <div class="row center">
        <div [ngClass]="environmentLogoClass" class="invite-title">Invitation Expired</div>
      </div>
      <div class="subTitle row">
        <span class="subtitle-header">This invitation has expired.</span>
        <span>Please request a new invitation from your system administrator.</span>
      </div>
    </div>
  }

  @if (screen === 'revoked') {
    <div class="content-area">
      <div class="row center">
        <div [ngClass]="environmentLogoClass" class="invite-title">Invitation Revoked</div>
      </div>
      <div class="subTitle row">
        <span class="subtitle-header">This invitation has been revoked.</span>
        <span>If you believe this is an error, please contact your system administrator to request a new invitation.</span>
      </div>
    </div>
  }

  @if (screen === 'invalid') {
    <div class="content-area">
      <div class="row center">
        <div [ngClass]="environmentLogoClass" class="invite-title">Invitation Invalid</div>
      </div>
      <div class="subTitle row">
        <span class="subtitle-header">This invitation is invalid.</span>
        <span>Please contact your system administrator to create a new invitation.</span>
      </div>
    </div>
  }
</div>
